'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _LoginSignup = require('./LoginSignup.scss');

var _LoginSignup2 = _interopRequireDefault(_LoginSignup);

var _Login = require('./Login');

var _Login2 = _interopRequireDefault(_Login);

var _Signup = require('./Signup');

var _Signup2 = _interopRequireDefault(_Signup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  LoginSignup: {
    displayName: 'LoginSignup'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Nav/LoginSignup.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

// import { connect } from 'react-redux';

// @connect(
//   state => ({
//     isOpenLoginSignup: state.session.openLoginSignup,
//   }))

var LoginSignup = _wrapComponent('LoginSignup')((_dec = (0, _reactCssModules2.default)(_LoginSignup2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(LoginSignup, _Component);

  function LoginSignup(props) {
    (0, _classCallCheck3.default)(this, LoginSignup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LoginSignup.__proto__ || (0, _getPrototypeOf2.default)(LoginSignup)).call(this, props));

    _this.onEmailUsed = _this.onEmailUsed.bind(_this);

    if (!(typeof _this.onEmailUsed === 'function')) {
      throw new TypeError('Value of "this.onEmailUsed" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.onEmailUsed));
    }

    return _this;
  }

  (0, _createClass3.default)(LoginSignup, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({ showSignup: this.props.showSignup });
    }
  }, {
    key: 'onSwitch',
    value: function onSwitch(type) {
      this.setState({ showSignup: type === 'signup' });
    }
  }, {
    key: 'onEmailUsed',
    value: function onEmailUsed(email) {
      this.setState({ showSignup: false, emailUsed: email });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react3.default.createElement(
        'div',
        { 'data-tmt': 'login-signup-modal' },
        _react3.default.createElement(
          'div',
          { styleName: 'switches-container' },
          _react3.default.createElement(
            'div',
            { className: 'signup-switcher', styleName: 'switch-container', onClick: this.onSwitch.bind(this, 'signup') },
            _react3.default.createElement(
              'h3',
              { styleName: this.state.showSignup ? 'switch-active' : 'switch' },
              'Sign Up'
            )
          ),
          _react3.default.createElement(
            'div',
            { className: 'login-switcher', styleName: 'switch-container', onClick: this.onSwitch.bind(this, 'login') },
            _react3.default.createElement(
              'h3',
              { styleName: this.state.showSignup ? 'switch' : 'switch-active' },
              'Log In'
            )
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'add-padding' },
          this.state.showSignup ? _react3.default.createElement(_Signup2.default, { swtich: true, allowGuest: this.props.allowGuest, onSwitchToLogin: this.onEmailUsed }) : _react3.default.createElement(_Login2.default, { 'switch': true, emailUsed: this.state.emailUsed })
        )
      );
    }
  }]);
  return LoginSignup;
}(_react2.Component), _class2.propTypes = {
  // callback: PropTypes.func,
  // isOpenLoginSignup: PropTypes.bool,
  allowGuest: _react2.PropTypes.bool,
  showSignup: _react2.PropTypes.bool
}, _class2.defaultProps = {
  showSignup: true
}, _temp)) || _class));

exports.default = LoginSignup;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Nav/LoginSignup.js
// module id = 1568
// module chunks = 47